import { React, useState } from "react"
import { Box, Grid } from "@mui/material"


import {  ButtonGrid, rootStyles } from "../styles/BuildingStyles"
import Title from "../parts/Title"
import CategoryButton from "../parts/CategoryButton"
import InputForm from "../parts/InputForm"
import FAQDialogWrapper from "../parts/FAQDialogWrapper"

function MontBlanc() {
    
    const [helpInfo, setHelpInfo] = useState({
        location: "Mont Blanc",
        category: "",
        building: "170"
    })
    const [clicked, setClicked] = useState({
        "TV": false,
        "Internet": false,
        "Other": false
    })

    const handleButtonClick = (category) => {
        setHelpInfo({ ...helpInfo, category: category })
        if (category === "TV") {
            setClicked({
                "TV": true,
                "Internet": false,
                "Other": false
            })
        }
        if (category === "Internet") {
            setClicked({
                "TV": false,
                "Internet": true,
                "Other": false
            })
        }
        if (category === "Computer") {
            setClicked({
                "TV": false,
                "Internet": false,
                "Other": false
            })
        }
        if (category === "Camera") {
            setClicked({
                "TV": false,
                "Internet": false,
                "Other": false
            })
        }
        if (category === "Other") {
            setClicked({
                "TV": false,
                "Internet": false,
                "Other": true
            })
        }
    }

    return (
        <Box sx={rootStyles}>
            <Title location="Mont Blanc" />
            <Grid container sx={ButtonGrid}>
                <CategoryButton
                    handleCategoryButtonClick={handleButtonClick}
                    clickedProp={clicked["TV"]}
                    category={"TV"}
                />
                <CategoryButton
                    handleCategoryButtonClick={handleButtonClick}
                    clickedProp={clicked["Internet"]}
                    category={"Internet"}
                />
                <CategoryButton
                    handleCategoryButtonClick={handleButtonClick}
                    clickedProp={clicked["Other"]}
                    category={"Other"}
                />
            </Grid>

            {clicked["TV"] && (
                <FAQDialogWrapper chosen={helpInfo} clickedObj={clicked} />
            )}

            <Grid container sx={ButtonGrid}>
                <InputForm infoChosen={helpInfo} />
            </Grid>
        </Box>
    )
}

export default MontBlanc
